import termsSummaryData from '../../components/TermsOfService/termsSummaryData';
import LegalDocument from './LegalDocument';

const TermsSummaryPage = () => (
  <LegalDocument
    data={termsSummaryData}
    relatedLinks={[
      { to: '/terms', label: 'Full Terms of Service' },
      { to: '/privacy', label: 'Privacy Policy' },
    ]}
  />
);

export default TermsSummaryPage;
